import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


const ClientsImage = () => {
  const images = [    
 

    {
      src:'images/logo/protinex.png',
      alt: 'Protinex',
    },
    {     
      src: 'images/logo/danone.png',
      alt: 'Danone',
    },
    {     
      src: 'images/logo/yakult.png',
      alt: 'Yakult',
    },
    {     
      src: 'images/logo/intex.png',
      alt: 'intex',
    },
    {     
      src: 'images/logo/savencia.png',
      alt: 'savencia',
    },
    {     
      src: 'images/logo/dna.png',
      alt: 'DNA',
    },
    {     
      src: 'images/logo/amri.png',
      alt: 'Amri',
    },
    {     
      src: 'images/logo/jindal-stainless.png',
      alt: 'jindal stainless',
    },
    {     
      src: 'images/logo/elle-vire.png',
      alt: 'Elle Vire',
    },
    {     
      src: 'images/logo/fonacc.png',
      alt: 'Fonacc',
    },
    {     
      src: 'images/logo/apl-apollo.png',
      alt: 'APL Apollo',
    },
    {     
      src: 'images/logo/bt.png',
      alt: 'BT',
    },
    {     
      src: 'images/logo/casio.png',
      alt: 'Casio',
    },
    {     
      src: 'images/logo/audio-technica.png',
      alt: 'Audio Technica',
    },
    {     
      src: 'images/logo/fortis.png',
      alt: 'Fortis',
    },
    {     
      src: 'images/logo/kings-college.png',
      alt: 'Kings College',
    },
    {     
      src: 'images/logo/u-grow.png',
      alt: 'U Grow',
    },
    {     
      src: 'images/logo/dps.png',
      alt: 'dps',
    },
    {     
      src: 'images/logo/zydus-wellness.png',
      alt: 'Zydus Wellness.png',
    },
    {     
      src: 'images/logo/nanavati.png',
      alt: 'Nanavati',
    },
    {     
      src: 'images/logo/sony.png',
      alt: 'Sony',
    },
    {     
      src: 'images/logo/audi.png',
      alt: 'Audi',
    },
    {     
      src: 'images/logo/mirari.png',
      alt: 'Mirari',
    },
    {     
      src: 'images/logo/kalco.png',
      alt: 'Kalco',
    },
    {     
      src: 'images/logo/aster.png',
      alt: 'aster',
    },
    {     
      src: 'images/logo/eissa-salem-lawyers.png',
      alt: 'Eissa Salem Lawyers',
    },
    {     
      src: 'images/logo/callaway.png',
      alt: 'Callaway Golf',
    },
    {     
      src: 'images/logo/ifutures.png',
      alt: 'Ifutures.png',
    },
    {     
      src: 'images/logo/somfy.png',
      alt: 'Somfy',
    },
    {     
      src: 'images/logo/mind-brain.png',
      alt: 'Mind Brain',
    },




    
    // Add more image URLs here
  ];
  

  return (
         
    <>
         <Container>
            <Row>
                <Col lg={12}>                              
                        {/* <Clients imageUrls={images} />   */}
                        {/* <div className='helpline'>                             
                            <Link href='#' className='bttn1 bttn2'> more clients </Link>
                        </div>  */}


                       
                        <div className="clients">
                       { images.map ((image) => (
                        <img src={image.src} alt={image.alt} />

                       ))  }                       
                        </div> 
                        <div className='helpline'>                             
                            <Link href='#' className='bttn1 bttn2'> more clients </Link>
                        </div>
                </Col>
            </Row>
        </Container>
    </>
            
     
      
    
  );
};

export default ClientsImage;
